export const compactPrice = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  if (n >= 1000000) {
    const m = n / 1000000;
    return `$${m >= 10 ? Math.round(m) : Math.round(m * 10) / 10}M`;
  }
  return `$${Math.round(n / 1000)}K`;
};

export const PRELOAD_NOTIFICATION_LINK = "My Properties";

export const preloadNotificationLead = (count) => {
  const n = Number(count) || 0;
  return `We added ${n} home${n === 1 ? "" : "s"} you helped buyers purchase to`;
};

export const purchaseYear = (value) => {
  const year = /^(\d{4})-\d{2}-\d{2}/.exec(String(value ?? ""))?.[1];
  return year ? Number(year) : null;
};
